import type { TFunction } from 'i18next'
import type { TruckConfiguration } from '#store/slices/configurationSlice'

export const lazyExportAndDownloadXlsx = async (configuration: TruckConfiguration, t: TFunction) => {
  const module = await import('./xlsx-exporter.ts')
  const { exportAndDownloadXlsx } = module
  await exportAndDownloadXlsx(configuration, t)
}

export const lazyExportOptionalEquipmentAndDownloadXlsx = async (configuration: TruckConfiguration | undefined, t: TFunction) => {
  if (!configuration) {
    return
  }
  const module = await import('./xlsx-exporter.ts')
  const { exportOptionalEquipmentAndDownloadXlsx } = module
  await exportOptionalEquipmentAndDownloadXlsx(configuration, t)
}
